import { render } from "./UploadFileForBin.vue?vue&type=template&id=6d2b532f"
import script from "./UploadFileForBin.vue?vue&type=script&lang=js"
export * from "./UploadFileForBin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__